import $ from 'jquery';
import Swiper from 'swiper/dist/js/swiper';
import onDocumentReady from '../util/onDocumentReady';

const aboutProduction = {};

const createSlider = (tab) => {
    if (aboutProduction[tab] !== undefined) {
        return false;
    }
    aboutProduction[tab] = new Swiper(`.about-production-tab--${tab} .swiper-container`, {
        speed: 600,
        slidesPerView: 1,
        pagination: {
            el: `.about-production-tab--${tab} .about-production-slider__pagination`,
            clickable: true,
        },
    });
    return true;
};

$('.about-production-tabs__item').click(function () {
    if ($(this).hasClass('about-production-tabs__item--active')) {
        return false;
    }
    const tab = $(this).attr('data-tab');

    // switch buttons
    $('.about-production-tabs__item').removeClass('about-production-tabs__item--active');
    $(this).addClass('about-production-tabs__item--active');

    // switch tabs
    $('.about-production-tab').hide();
    $(`.about-production-tab--${tab}`).fadeIn();

    // slider
    createSlider(tab);
    return true;
});

onDocumentReady(() => {
    $('.about-production-tabs__item').first().click();
});
